import { defaultLocale, isLocale, type Locale } from "@/lib/i18n/locales";

/**
 * Prefixes an internal path with the locale segment. Idempotent if already prefixed.
 * Use for paths like `/blog` or `/expertise/foo` from slRoutes.
 */
export function localizedPath(path: string, locale: Locale): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  const first = normalized.split("/").filter(Boolean)[0];
  if (first != null && isLocale(first)) {
    return normalized;
  }
  if (normalized === "/") {
    return `/${locale}`;
  }
  return `/${locale}${normalized}`;
}

export function localeFromParams(value: string | string[] | undefined): Locale {
  const raw = Array.isArray(value) ? value[0] : value;
  return isLocale(raw) ? raw : defaultLocale;
}

/** Pathname without leading `/{locale}` for comparisons with slRoutes paths. */
export function stripLocaleFromPathname(pathname: string): string {
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length > 0 && isLocale(parts[0])) {
    const rest = parts.slice(1).join("/");
    return rest ? `/${rest}` : "/";
  }
  return pathname.startsWith("/") ? pathname : `/${pathname}`;
}
